export default __webpack_public_path__ + "static/media/settingsIcon.ae22a4cb.svg";